/**
 * Restructed by he.zhikai
 * Restructed on 2017-11-24
 */
'use strict';
angular
    .module('resourceCenterSharedModule', [
        'resCenterGXRouterModule',
        'sharedQuickPreviewModule',
        'allOpersModule',
        // 'autoPicModule',
        'deleteSharedManuscriptServiceModule',
    ])
    .controller('resourceCenterSharedCtrl', [
        '$scope',
        '$q',
        '$element',
        '$filter',
        '$stateParams',
        '$state',
        '$timeout',
        'initComDataService',
        'trsHttpService',
        'resourceCenterService',
        'resCtrModalService',
        'modalDialog',
        'trsspliceString',
        'localStorageService',
        '$sessionStorage',
        'storageListenerService',
        'trsPrintService',
        'editingCenterService',
        'deleteSharedManuscriptService',
        'resSharedService',
        'mediaIconObj',
        'editingMediaName',
        'shareDocApiService',
        function (
            $scope,
            $q,
            $element,
            $filter,
            $stateParams,
            $state,
            $timeout,
            initComDataService,
            trsHttpService,
            resourceCenterService,
            resCtrModalService,
            modalDialog,
            trsspliceString,
            localStorageService,
            $sessionStorage,
            storageListenerService,
            trsPrintService,
            editingCenterService,
            deleteSharedManuscriptService,
            resSharedService,
            mediaIconObj,
            editingMediaName,
            shareDocApiService
        ) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.comeFrom = 'source.sharedoc';
                $scope.hasCKPicRights = {};
                $scope.status = {
                    showGgdwWrap: false, // 供稿单位框
                    isOpenedPanel: {
                        0: true,
                    }, // 第一块版面默认打开
                    hasphoto: $state.params.nodename.indexOf('图片总汇') > -1, // 是否显示图集
                    isMedia: false, // 是否为本媒体稿件
                    btnRights: {}, // 按钮权限
                    methodname: {
                        // 打印操作的查看详情方法名
                        1: 'getNewsShareDoc',
                        2: 'getPicsShareDoc',
                        4: 'getLinkShareDoc',
                        7: 'getVideoShareDoc',
                        8: 'getLiveShareDoc',
                    },
                    screenWrapSelected: false, // 是否显示更多筛选
                    singleGraph: false, // 是否为单图模式
                    isESSearch: false, // 是否进行ES检索
                    isUGC: $state.params.isugc === '1', // 是否是ugc稿件
                    UGCSearch: false, // 是否进行ugc检索
                    isDataOfFirst: !angular.isDefined($state.params.parentid),
                    curPanelIndex: 0,
                    isCountyFeed: $state.params.manutype === 'countyFeedList', // 判断是否是县融供稿
                    listMode: resSharedService.getListMode(), // 数据呈现方式，模式为列表模式, banmian: 版面模式
                    isBanmianSearch: false,
                    isCrossTenant: $state.params.iscrosstenant === '1'
                };
                $scope.childStatus = {
                    checkString: $scope.status.isUGC ? 'picUrlList' : 'DOC_PICTURELIST',
                    picString: $scope.status.isUGC ? 'url' : 'PERPICURL',
                    originPicUrl: $scope.status.isUGC ? 'url' : 'SRCPICURL', // 原图字段
                    url: 'resourcegxgkdetail',
                    isShowAtlasShared: true, // 图集模式是否展示共享人
                    isCountyFeed: $state.params.manutype === 'countyFeedList' // 判断是否是县融供稿
                };
                $scope.data = {
                    editingMediaName: editingMediaName,
                    iconObj: mediaIconObj.iconObj, // 推荐渠道标识
                    originArray: [], // 原始租户数据
                    SharedTenantName: '', // 供稿单位输入框
                    casDataArea: [], // 地区的级联数组
                    items: [], // 图集数据
                    selectedArray: [], // 选中的数据
                    operFlags: [], // 取签见撤重
                    printResult: [], // 打印详情
                    selectedArrat: [], // 缓存中选中的对象
                    selectType: '', // 检索的类型
                    keywords: '', // 检索的关键词
                    areaId: '', // 当前选中的地域id
                    itemCounts: 0, // 显示的稿件数量
                    getListPage: {}, // 分页请求判断分页数据
                    sharedTenant: {
                        data: [],
                        curValue: {},
                    }, // 供稿单位对象
                };
                $scope.basicParams = {
                    // 基础参数
                    channelName: 'gxgk',
                    typeName: $stateParams.typename && $stateParams.typename.replace('zyzx', ''),
                    nodeId: $stateParams.nodeid,
                    nodename: decodeURINodeName($stateParams.nodename),
                };
                $scope.page = {
                    // 分页信息
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                };
                $scope.params = {
                    // 请求参数
                    serviceid: 'mlf_releaseSource',
                    methodname: 'queryShareDocsDataCount',
                    CurrPage: $scope.page.CURRPAGE,
                    PageSize: 10,
                    MetaCategoryId: $stateParams.nodeid,
                    DocType: '', // 稿件类型
                    ShareTimeStart: '', // 开始日期
                    ShareTimeEnd: '', // 结束
                    OriginalType: '', // 原创稿类型
                    IsUnit: false, // 本媒体稿件
                    fromTenantId: '' // 供稿单位id
                };
                $scope.ugcParams = {
                    serviceid: 'mlf_ugc',
                    methodname: 'queryArticleCount',
                    Method: 'queryArticleCount',
                    MetaCategoryId: $scope.status.isDataOfFirst ? '' : $stateParams.nodeid,
                    start: '',
                    FirstClassId: $scope.status.isDataOfFirst ? $stateParams.nodeid : '',
                    end: '',
                };
            }

            /**
             * [isNaN description] 判断是否是数字
             * @param  {[type]}  number [description]
             * @return {Boolean}        [description]
             */
            $scope.isNaN = function (number) {
                return isNaN(number);
            };

            /**
             * [decodeURINodeName description] 强行兼容解码问题造成的nodename为编码后的形态的情况
             * @param  {[type]} nodename [description] 节点名
             * @return {[type]}          [description]
             */
            function decodeURINodeName(nodename) {
                if (!nodename) {
                    return nodename;
                }
                var name = nodename;
                while (name.indexOf('%') > -1) {
                    name = decodeURIComponent(name);
                }
                return name;
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                listenStorage();
                initDropDown().then(function () {
                    if (angular.isDefined($scope.$root.filterDataBack)) {
                        // 判断是否有传递的数据
                        var filterDataBack = angular.copy($scope.$root.filterDataBack);
                        $scope.page = filterDataBack.page;
                        $scope.params.CurrPage = $scope.page.CURRPAGE;
                        $scope.params.PageSize = $scope.page.PAGESIZE;
                        $scope.data.fromdate = filterDataBack.fromdate;
                        $scope.data.untildate = filterDataBack.untildate;
                        $scope.params = filterDataBack.params;
                        $scope.docType = filterDataBack.docType; // 稿件类型
                        $scope.originType = filterDataBack.originType; // 原创稿类型
                        $scope.status.isMedia = filterDataBack.isMedia; // 是否本媒体稿件
                        $scope.keyType = filterDataBack.keyType; // 当前检索信息
                        $scope.data.keywords = filterDataBack.keywords; // 当前检索词
                        // 默认展开更多筛选项
                        if ($scope.docType.curValue.value || $scope.originType.curValue.value || filterDataBack.area) {
                            $scope.status.screenWrapSelected = true;
                        }
                        // 默认选中的地域信息
                        if (filterDataBack.area) {
                            $scope.data.casDataArea.push(filterDataBack.area[0]);
                        }
                        if (filterDataBack.panelsData) {
                            // 分组数据
                            $scope.data.panels = angular.copy(filterDataBack.panelsData);
                            $scope.status.isOpenedPanel = angular.copy(filterDataBack.isOpenedPanel); // 默认展开项
                            dealWithPanelData($scope.data.panels);
                        }
                        if (filterDataBack.listData && filterDataBack.listData.length > 0) {
                            // 不是分组列表的情况
                            if (angular.isDefined(filterDataBack.singleGraph)) {
                                // 是否是图集稿
                                $scope.status.hasphoto = true;
                                $scope.status.singleGraph = filterDataBack.singleGraph; // 是否单图
                                var items = filterDataBack.listData;
                                $timeout(function () {
                                    $scope.data.items = items;
                                    initOperFlag($scope.data.items);
                                }, 100);
                                // dealWithPicList($scope.data.items);
                            } else if (angular.isDefined(filterDataBack.isESSearch) || angular.isDefined(filterDataBack.UGCSearch)) {
                                // ESS检索，普通列表
                                $scope.status.isESSearch = filterDataBack.isESSearch;
                                $scope.status.UGCSearch = filterDataBack.UGCSearch;
                                if ($scope.status.UGCSearch) {
                                    $scope.status.isUGC = true;
                                    $scope.data.UGCsearchItems = angular.copy(filterDataBack.listData);
                                }
                                $scope.data.items = angular.copy(filterDataBack.listData);
                                $scope.data.operFlags = [];
                                initOperFlag($scope.data.items);
                                getDraftRecord($scope.data.items);
                                requestListImg($scope.data.items);
                                getGroupIssuedCounts($scope.data.items);
                            }
                        }
                    }
                    requestData();
                    $scope.$on('$destroy', function () {
                        // 销毁对象
                        delete $scope.$root.filterDataBack;
                    });
                    initBtnRight();
                });
            }

            /**
             * [dealWithPanelData description]处理快速预览返回时，分组展示groupData传递数据的取签见撤重
             * @param  {[type]} panels [description]
             * @return {[type]}        [description]
             */
            function dealWithPanelData(panels) {
                if (panels) {
                    for (var j = 0; j < panels.length; j++) {
                        if (angular.isDefined(panels[j].DOCUMENTS) && panels[j].DOCUMENTS.length > 0) {
                            initOperFlag($scope.data.panels[j].DOCUMENTS); // 初始化取签见撤重
                            getDraftRecord($scope.data.panels[j].DOCUMENTS); // 取稿人
                            requestListImg($scope.data.panels[j].DOCUMENTS);
                            getGroupIssuedCounts($scope.data.panels[j].DOCUMENTS);
                            (function (k) {
                                // 立即执行函数
                                getRelatedMedias($scope.data.panels[k].DOCUMENTS, k);
                            })(j);
                        }
                    }
                }
            }

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenResource(function () {
                    requestData();
                    storageListenerService.removeListener('resource');
                }, $scope);
            }

            /**
             * [initDropDown description] 初始化下拉列表数据
             * @return {[type]} [description]
             */
            function initDropDown() {
                var defer = $q.defer();
                $scope.docType = {
                    data: initComDataService.shareNewsType(),
                    curValue: $state.params.nodename.indexOf('图片总汇') > -1 ? initComDataService.shareNewsType()[2] : initComDataService.shareNewsType()[0],
                };
                if ($scope.status.isUGC) {
                    $scope.docType.data.splice(4);
                }
                $scope.params.DocType = $scope.docType.curValue.value;
                $scope.keyType = {
                    data: initComDataService.addNewSearchType(),
                    // data: initComDataService.searchKeyType(),
                    curValue: initComDataService.searchKeyType()[0],
                };
                if ($state.params.isugc !== '1') {
                    $scope.keyType.data.push({
                        name: '作者',
                        value: 'AuthorTruename'
                    });
                }
                // 县荣稿库和通讯员稿库不需要 共享人检索条件
                if ($state.params.isugc !== '1' && !$state.params.manutype) {
                    $scope.keyType.data.push({
                        name: '共享人',
                        value: 'Cruser'
                    });
                }
                $scope.originType = {
                    data: initComDataService.originType(),
                    curValue: initComDataService.originType()[0],
                };
                initTenant();
                initcompositeFilter();
                defer.resolve();
                return defer.promise;
            }

            /**
             * [initTenant description] 初始化供稿单位
             *
             * @return  {[type]}  [return description]
             */
            function initTenant() {
                // 判断如果不是县融供稿不执行此请求
                if ($state.params.manutype !== 'countyFeedList') {
                    return;
                }
                var params = {
                    serviceid: 'mlf_releaseSource',
                    methodName: 'queryHaveSharedTenantName'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    // $scope.data.sharedTenant.data = [{
                    //     FromTenantId: '',
                    //     FromTenantName: '全部供稿单位'
                    // }].concat(data);
                    $scope.data.sharedTenant.data = data;
                    $scope.data.originArray = $scope.data.sharedTenant.data;
                    $scope.data.sharedTenant.curValue = $scope.data.sharedTenant.data[0];
                });
            }

            /**
             * [initcompositeFilter description]
             *
             * @return  {[type]}  [return description]
             */
            function initcompositeFilter() {
                var userId = $sessionStorage.get('curUserInfo').ID;
                var storage = localStorageService.get('resource.compositeFilter');
                if (storage && storage[userId]) {
                    // $scope.status.screenWrapSelected = storage[userId].screenWrapSelected;
                    $scope.status.takeDraftStatus = $scope.params.takeDraftStatus = storage[userId].takeDraftStatus;
                    $scope.status.singStatus = $scope.params.singStatus = storage[userId].singStatus;
                    $scope.status.products = $scope.params.products = storage[userId].products;
                }
                if ($scope.status.takeDraftStatus || $scope.status.singStatus || $scope.status.products !== '[]') {
                    $scope.status.screenWrapSelected = true;
                }
            }

            /**
             * [requestData description]请求列表数据
             *
             * @param   {[type]}  isPageChanged  [isPageChanged description]
             *
             * @return  {[type]}                 [return description]
             */
            function requestData(isPageChanged) {
                if (!isPageChanged) {
                    $scope.page.CURRPAGE = 1;
                }
                $scope.data.selectedArray = [];
                if ($scope.status.isESSearch === true) {
                    requestESSearch();
                } else if ($scope.params.DocType === '2') {
                    if ($scope.status.isUGC) {
                        UGCSearch();
                    } else {
                        requestImgFlow();
                    }
                } else if ($scope.status.isDataOfFirst && $scope.status.isUGC !== true) {
                    requestCountOfFirst();
                } else {
                    $scope.status.UGCSearch = false;
                    getUgcData();
                }
            }

            /**
             * [getUgcData 获取通讯员稿库数据]
             *
             * @return  {[type]}  [return description]
             */
            function getUgcData() {
                if ($scope.status.listMode === 'banmian') {
                    let params;
                    if ($scope.status.isUGC === true) {
                        $scope.ugcParams.start = $scope.data.fromdate || '';
                        $scope.ugcParams.end = $scope.data.untildate || '';
                        params = angular.copy($scope.ugcParams);
                    } else {
                        params = angular.copy($scope.params);
                    }
                    params.articleType = getUGCArticleType();
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        // 判断获取数据是否为ugc稿件
                        if ($scope.status.isUGC === true) {
                            $scope.data.panels = data.data;
                            $scope.data.operFlags = [];
                        } else {
                            $scope.data.panels = data;
                        }
                        angular.forEach($scope.data.panels, function (value, key) {
                            value.currPage = 1;
                        });
                        if ($scope.data.panels.length > 0) {
                            angular.forEach($scope.status.isOpenedPanel, function (value, key) {
                                queryItemsByPanel(key);
                            });
                        }
                    });
                } else {
                    queryItemsByPanel();
                }
            }

            /**
             * [requestDataOfFirst description] 一级目录获取稿件数
             * @return {[type]} [description]
             */
            function requestCountOfFirst() {
                if ($scope.status.listMode === 'banmian') {
                    var params = {
                        serviceid: 'mlf_releaseSource',
                        methodname: 'queryShareDocsDataCountOfFirst',
                        MetaCategoryId: $stateParams.nodeid,
                        IsUnit: $scope.status.isMedia,
                        CurrPage: $scope.page.CURRPAGE,
                        PageSize: $scope.page.PAGESIZE,
                        DocType: $scope.docType.curValue.value,
                        OriginalType: $scope.originType.curValue.value == '0' ? '' : $scope.originType.curValue.value,
                        ShareTimeStart: $scope.data.fromdate || '',
                        ShareTimeEnd: $scope.data.untildate || '',
                        takeDraftStatus: $scope.status.takeDraftStatus,
                        DocShareMedia: $scope.status.docShareMedia,
                        products: $scope.status.products,
                    };
                    if ($scope.status.takeDraftStatus !== 2) {
                        params.singStatus = $scope.status.singStatus;
                    }
                    if ($scope.status.isCountyFeed) {
                        params.fromTenantId = $scope.params.fromTenantId;
                    }
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        $scope.data.panels = data;
                        angular.forEach($scope.data.panels, function (value, key) {
                            value.currPage = 1;
                        });
                        if ($scope.data.panels.length > 0) {
                            angular.forEach($scope.status.isOpenedPanel, function (value, key) {
                                if (value){
                                    queryItemsByPanel(key);
                                }
                            });
                        }
                    });
                } else {
                    queryItemsByPanel();
                }
            }

            /**
             * [initBtnRight description] 获取按钮权限
             * @return {[type]} [description]null
             */
            function initBtnRight() {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeysOfNormalModal',
                    ModalName: '资源中心',
                    Classify: 'source.sharedoc',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    angular.forEach(data, function (value, key) {
                        $scope.status.btnRights[value.OPERNAME] = value;
                    });
                });
            }

            /**
             * [showPostTime description] 显示ugc稿件共享时间
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.showPostTime = function (item) {
                var postTime = $filter('date')(item.postTime, 'yyyy-MM-dd HH:mm:ss').toString();
                return postTime;
            };

            /**
             * [getUGCarticleType 获取UGC稿件文章类型]
             *
             * @return  {[type]}  [return description]
             */
            function getUGCArticleType() {
                return {
                    1: '0',
                    2: '3',
                    7: '2',
                }[$scope.docType.curValue.value] || undefined;
            }

            /**
             * [queryUGCItemsByPanel description] 请求UGC数据
             * @param   {[type]}  index  [index description]
             * @return  {[type]}         [return description]
             */
            function queryUGCItemsByPanel(index) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_ugc',
                    methodname: 'queryArticles',
                    Method: 'queryArticles',
                    MetaCategoryId: !$scope.status.isDataOfFirst ? $stateParams.nodeid : '',
                    ContainPage: '0',
                    start: $scope.status.listMode === 'banmian' ? $scope.data.panels[index].MDATE : $scope.data.fromdate,
                    end: $scope.status.listMode === 'banmian' ? $scope.data.panels[index].MDATE : $scope.data.untildate,
                    FirstClassId: $scope.status.isDataOfFirst ? $stateParams.nodeid : '',
                    // takeDraftStatus: $scope.status.takeDraftStatus
                };
                params.articleType = getUGCArticleType();
                // if ($scope.status.takeDraftStatus !== 2) {
                //     params.singStatus = $scope.status.singStatus;
                //     params.products = $scope.status.products;
                // }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    data = data.data;
                    angular.forEach(data, function (value, key) {
                        value.METADATAID = value.id + '';
                        value.DOCTYPEID = value.docType + '';
                    });
                    if ($scope.status.listMode === 'banmian') {
                        $scope.data.panels[index].DOCUMENTS = data;
                    } else {
                        $scope.data.items = data;
                    }
                    deffer.resolve();
                    initOperFlag(data);
                    if ($scope.status.listMode === 'banmian') {
                        getDraftRecord($scope.data.panels[index].DOCUMENTS);
                        getGroupIssuedCounts($scope.data.panels[index].DOCUMENTS);
                        // 储存翻页信息
                        storageListenerService.previewPageTurningStorage($scope.data.panels[index].DOCUMENTS, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                    } else {
                        getDraftRecord($scope.data.items);
                        getGroupIssuedCounts($scope.data.items);
                        // 储存翻页信息
                        storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                    }

                    localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
                });
                return deffer.promise;
            }

            /**
             * [queryFirstItemsByPanel description] 获取一级分类数据
             * @param  {[type]} index [description] 索引
             * @return {[type]}       [description]
             */
            function queryFirstItemsByPanel(index) {
                if ($scope.status.listMode === 'banmian') {
                    if (!$scope.data.getListPage[index] || $scope.status.isBanmianSearch) {
                        $scope.data.getListPage[index] = {
                            page: 1,
                        };
                        $scope.status.isBanmianSearch = false;
                    } else {
                        $scope.data.getListPage[index].page += 1;
                    }
                }
                var defer = $q.defer();
                var params = {};
                params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'queryShareDocsForCloudOfFirst',
                    MetaCategoryId: $stateParams.nodeid,
                    IsUnit: $scope.status.isMedia,
                    CurrPage: $scope.status.listMode === 'banmian' ? $scope.data.getListPage[index].page : $scope.page.CURRPAGE,
                    PageSize: $scope.status.listMode === 'banmian' ? 10 : $scope.page.PAGESIZE,
                    DocType: $scope.docType.curValue.value,
                    OriginalType: $scope.originType.curValue.value == '0' ? '' : $scope.originType.curValue.value,
                    ShareTimeStart: $scope.data.fromdate || '',
                    ShareTimeEnd: $scope.data.untildate || '',
                    takeDraftStatus: $scope.status.takeDraftStatus,
                    DocShareMedia: $scope.status.docShareMedia,
                    products: $scope.status.products,
                };
                if ($scope.status.takeDraftStatus !== 2) {
                    params.singStatus = $scope.status.singStatus;
                }
                if ($scope.status.listMode === 'banmian') {
                    params = angular.extend(params, {
                        ShareTimeStart: angular.isDefined(index) ? $scope.data.panels[index].MDATE + ' 00:00:00' : $scope.data.fromdate || '',
                        ShareTimeEnd: angular.isDefined(index) ? $scope.data.panels[index].MDATE + ' 23:59:59' : $scope.data.untildate || '',
                    });
                }
                if ($scope.status.isCountyFeed) {
                    params.fromTenantId = $scope.params.fromTenantId;
                }
                $scope.loadingPromise = trsHttpService
                    .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function (data) {
                        if ($scope.status.listMode === 'banmian') {
                            $scope.data.panels[index].DOCUMENTS = $scope.data.panels[index].DOCUMENTS
                                ? $scope.data.panels[index].DOCUMENTS.concat(data.DATA)
                                : data.DATA;
                            $scope.data.panels[index].pageCount = data.PAGER.PAGECOUNT;
                            defer.resolve();
                            return initOperFlag($scope.data.panels[index].DOCUMENTS);
                        } else {
                            $scope.data.items = data.DATA;
                            $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                            $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                            defer.resolve();
                            return initOperFlag($scope.data.items);
                        }
                    })
                    .then(function () {
                        if ($scope.status.listMode === 'banmian') {
                            getDraftRecord($scope.data.panels[index].DOCUMENTS);
                            requestListImg($scope.data.panels[index].DOCUMENTS);
                            getGroupIssuedCounts($scope.data.panels[index].DOCUMENTS);
                            getRelatedMedias($scope.data.panels[index].DOCUMENTS, index);
                            // 储存翻页信息
                            storageListenerService.previewPageTurningStorage(
                                $scope.data.panels[index].DOCUMENTS,
                                'METADATAID,DOCTYPEID',
                                'fusiongxgPreview'
                            );
                        } else {
                            getDraftRecord($scope.data.items);
                            requestListImg($scope.data.items);
                            getGroupIssuedCounts($scope.data.items);
                            getRelatedMedias($scope.data.items);
                            // 储存翻页信息
                            storageListenerService.previewPageTurningStorage(
                                $scope.data.items,
                                'METADATAID,DOCTYPEID',
                                'fusiongxgPreview'
                            );
                        }

                        localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
                    });
                return defer.promise;
            }

            /**
             * [queryItemsByPanel description] 请求每个面板下的稿件
             * @return {[type]}       [description]
             */
            function queryItemsByPanel(index) {
                let key = index !== undefined ? index : '';
                var deffer = $q.defer();
                if ($scope.status.isUGC) {
                    queryUGCItemsByPanel(key).then(function () {
                        deffer.resolve();
                    });
                } else if ($scope.status.isDataOfFirst) {
                    queryFirstItemsByPanel(key).then(function () {
                        deffer.resolve();
                    });
                } else {
                    var params = angular.copy($scope.params);
                    params.methodname = 'queryShareDocsForCloud';
                    params.ShareTimeStart = $scope.data.fromdate;
                    params.ShareTimeEnd = $scope.data.untildate;
                    params.PageSize = $scope.status.listMode === 'banmian' ? 10 : $scope.page.PAGESIZE;
                    params.CurrPage = $scope.status.listMode === 'banmian' ? $scope.data.panels[index].currPage : $scope.page.CURRPAGE;
                    params.OriginalType = params.OriginalType == '0' ? '' : params.OriginalType;
                    if ($scope.status.listMode === 'banmian') {
                        params.ShareTimeStart = $scope.data.panels[index].MDATE + ' 00:00:00';
                        params.ShareTimeEnd = $scope.data.panels[index].MDATE + ' 23:59:59';
                    }
                    if ($scope.status.takeDraftStatus !== 2) {
                        params.singStatus = $scope.status.singStatus;
                    } else {
                        params.singStatus = undefined;
                        delete params.singStatus;
                    }
                    $scope.loadingPromise = trsHttpService
                        .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                        .then(function (data) {
                            if ($scope.status.listMode === 'banmian') {
                                $scope.data.panels[index].DOCUMENTS = $scope.data.panels[index].DOCUMENTS
                                    ? $scope.data.panels[index].DOCUMENTS.concat(data.DATA)
                                    : data.DATA;
                                $scope.data.panels[index].pageCount = data.PAGER.PAGECOUNT;
                                for (var i = 0; i < $scope.data.panels[index].DOCUMENTS.length; i++) {
                                    $scope.data.panels[index].DOCUMENTS[i].FGDAUTHOR = trsspliceString.spliceString(
                                        $scope.data.panels[index].DOCUMENTS[i].FGD_AUTHINFO,
                                        'USERNAME',
                                        ' '
                                    );
                                }
                                deffer.resolve();
                                return initOperFlag($scope.data.panels[index].DOCUMENTS);
                            } else {
                                $scope.data.items = data.DATA;
                                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                                for (var i = 0; i < $scope.data.items.length; i++) {
                                    $scope.data.items[i].FGDAUTHOR = trsspliceString.spliceString(
                                        $scope.data.items[i].FGD_AUTHINFO,
                                        'USERNAME',
                                        ' '
                                    );
                                }
                                deffer.resolve();
                                return initOperFlag($scope.data.items);
                            }
                        })
                        .then(function () {
                            if ($scope.status.listMode === 'banmian') {
                                getDraftRecord($scope.data.panels[index].DOCUMENTS);
                                requestListImg($scope.data.panels[index].DOCUMENTS);
                                getGroupIssuedCounts($scope.data.panels[index].DOCUMENTS);
                                getRelatedMedias($scope.data.panels[index].DOCUMENTS, index);
                                // 储存翻页信息
                                storageListenerService.previewPageTurningStorage(
                                    $scope.data.panels[index].DOCUMENTS,
                                    'METADATAID,DOCTYPEID',
                                    'fusiongxgPreview'
                                );
                                localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
                            } else {
                                getDraftRecord($scope.data.items);
                                requestListImg($scope.data.items);
                                getGroupIssuedCounts($scope.data.items);
                                getRelatedMedias($scope.data.items);
                                // 储存翻页信息
                                storageListenerService.previewPageTurningStorage(
                                    $scope.data.items,
                                    'METADATAID,DOCTYPEID',
                                    'fusiongxgPreview'
                                );
                                localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
                            }
                        });
                }
                return deffer.promise;
            }

            /**
             * [getRelatedMedias description] 查询已关联的渠道和关联渠道的虚拟稿件是否提交
             * @param  {[type]} items [description] 我的稿件
             * @return {[type]}       [description]
             */
            /**
             * [getRelatedMedias description] 查询已关联的渠道和关联渠道的虚拟稿件是否提交
             *
             * @param   {[array]}   items  [items description] 稿件集合
             * @param   {[number]}  index  [index description] 集合序号
             * @return  {[type]}         [return description]
             */
            function getRelatedMedias(items, index) {
                var defer = $q.defer();
                if (!items || items.length < 1) {
                    defer.resolve([]);
                } else {
                    var params = {
                        serviceid: 'mlf_fusioncreate',
                        methodname: 'queryMediaRelateAndSubmitStatus',
                        MetaDataIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        if ($scope.status.listMode === 'banmian') {
                            angular.forEach($scope.data.panels[index].DOCUMENTS, function (value, key) {
                                value.relatedMedias = data[value.METADATAID];
                            });
                        } else {
                            angular.forEach($scope.data.items, function (value, key) {
                                value.relatedMedias = data[value.METADATAID];
                            });
                        }
                        defer.resolve(data);
                    });
                }
                return defer.promise;
            }

            /**
             * [initOperFlag description] 获取取签见撤重信息
             * @param  {[type]} documents [description] 当前面板或ES列表数据
             * @return {[type]}           [description]
             */
            function initOperFlag(documents) {
                var deferred = $q.defer();
                var docIds = trsspliceString.spliceString(documents, 'METADATAID', ',');
                if (docIds) {
                    var params;
                    if ($scope.status.isUGC === true) {
                        params = {
                            serviceid: 'mlf_ugc',
                            methodname: 'queryFlag',
                            UgcIds: docIds,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                            var temp = data;
                            for (var i in temp) {
                                if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                                    data[i].METADATAID = data[i].UGCID;
                                    $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                                }
                            }
                            deferred.resolve();
                        });
                    } else {
                        params = angular.extend($scope.basicParams, {
                            MetaDataIds: docIds,
                        });
                        resourceCenterService.getWcmTags(params).then(function (data) {
                            var temp = data;
                            for (var i in temp) {
                                if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                                    $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                                }
                            }
                            deferred.resolve();
                        });
                    }
                } else {
                    deferred.resolve();
                }
                return deferred.promise;
            }

            /**
             * [getDraftRecord description] 获得取稿件人
             * @param  {[type]} items [description] 当前面板或ES列表数据
             * @return {[type]}       [description]
             */
            function getDraftRecord(items) {
                if (items.length === 0) {
                    return;
                }
                var params = {
                    serviceid: 'mlf_releasesource',
                    methodname: 'queryQuOpers',
                    MetaDataIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function (data) {
                    for (var i = 0; i < items.length; i++) {
                        var operUsers = data[items[i].METADATAID];
                        operUsers = $filter('unique')(operUsers, 'OPERUSER');

                        items[i].OPERUSER = trsspliceString.spliceString(operUsers, 'OPERUSER', ' ').split(' ');
                    }
                });
            }

            /**
             * [requestListImg description] 查询列表图示
             * @param  {[type]} items [description] 当前面板或ES列表数据
             * @return {[type]}       [description]
             */
            function requestListImg(items) {
                if (items.length === 0) {
                    return;
                }
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'queryAllImgLogo',
                    metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    angular.forEach(items, function (value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
            }

            /**
             * [getGroupIssuedCounts description] 获取集团已发数
             * @param  {[type]} items [description] 当前所有稿件
             * @return {[type]}       [description]
             */
            function getGroupIssuedCounts(items) {
                var params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'queryGroupIssuedCounts',
                    MetaDataIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    angular.forEach(items, function (value, key) {
                        value.ISSUEDCOUNTS = data[value.METADATAID];
                    });
                });
            }

            /**
             * [showOperFlag description] 显示取签见撤重标志
             * @param  {[type]} guid      [description] 稿件id
             * @param  {[type]} flagIndex [description] 取签见撤重序号
             * @return {[type]}           [description]
             */
            $scope.showOperFlag = function (guid, flagIndex) {
                var temp = queryItemBYGUID(guid);
                if (!!temp) {
                    return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) === '1';
                } else {
                    return false;
                }
            };

            /**
             * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
             * @param  {[type]} guid [description] 稿件id
             * @return {[type]}      [description]
             */
            function queryItemBYGUID(guid) {
                for (var i in $scope.data.operFlags) {
                    if (guid == $scope.data.operFlags[i].METADATAID) {
                        return $scope.data.operFlags[i];
                    }
                }
            }

            /**
             * [viewInfo description] 取签见撤重 点击弹出
             * @param   {[type]}  ChnlDocId   [ChnlDocId description] 稿件id
             * @param   {[type]}  showRepeat  [showRepeat description] 类型
             * @param   {[type]}  showClick   [showClick description]
             * @param   {[type]}  isUGC       [isUGC description]
             * @return  {[type]}              [return description]
             */
            $scope.viewInfo = function (ChnlDocId, showRepeat, showClick, isUGC) {
                var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
                resCtrModalService.infoModal(ChnlDocId, showRepeat, showClick, operFlags, isUGC, undefined, undefined, $scope.status.isCrossTenant);
            };

            /**
             * [quickPreview description] 快速预览模式
             * @return {[type]} [description]
             */
            $scope.quickPreview = function () {
                var params = angular.copy($scope.params);
                params.methodname = 'queryShareDocsDataCountOfFirst';
                $scope.$root.filterData = {
                    page: $scope.page, // 分页
                    fromdate: $scope.data.fromdate, // 开始时间
                    untildate: $scope.data.untildate, // 结束时间
                    params: params, // 其他条件
                    area: $scope.data.area, // 地域信息
                    docType: $scope.docType, // 稿件类型
                    originType: $scope.originType, // 原创稿类型
                    keyType: $scope.keyType, // 当前检索信息
                    isMedia: $scope.status.isMedia, // 是否本媒体稿件
                    keywords: $scope.data.keywords, // 当前检索词
                    sharedTenant: $scope.data.sharedTenant // 记录供稿单位信息
                };
                if ($scope.status.hasphoto) {
                    // 是否图集稿，是则直接传递图集列表数据
                    $scope.$root.filterData.listData = $scope.data.items;
                    $scope.$root.filterData.singleGraph = $scope.status.singleGraph; // 是否单图
                } else if ($scope.status.isESSearch) {
                    // ESS检索
                    $scope.$root.filterData.listData = $scope.data.items;
                    $scope.$root.filterData.isESSearch = $scope.status.isESSearch;
                } else if ($scope.status.UGCSearch) {
                    // ugc检索
                    $scope.$root.filterData.listData = $scope.data.items;
                    $scope.$root.filterData.UGCSearch = $scope.status.UGCSearch;
                } else {
                    // 分组列表
                    $scope.$root.filterData.panelsData = $scope.data.panels;
                    $scope.$root.filterData.isOpenedPanel = angular.copy($scope.status.isOpenedPanel);
                }
                $state.go('front.resourcectrl.share.quickpreview', $stateParams);
            };

            /**
             * [searchWithKeyword description] 根据条件筛选稿件
             * @param  {[type]} key   [description] 筛选类型
             * @param  {[type]} value [description] 筛选内容
             * @return {[type]}       [description]
             */
            $scope.searchWithKeyword = function (key, value) {
                if (key === 'ShareTime') {
                    $scope.params.ShareTimeStart = $scope.data.fromdate;
                    $scope.params.ShareTimeEnd = $scope.data.untildate;
                } else {
                    $scope.params[key] = value;
                }
                if (key === 'DocType' && value !== '2') {
                    $scope.status.hasphoto = false;
                } else if (key === 'DocType' && value === '2') {
                    $scope.status.hasphoto = true;
                }
                $scope.params.CurrPage = $scope.page.CURRPAGE = 1;
                $scope.data.items = [];
                if ($scope.status.listMode === 'banmian') {
                    $scope.status.isBanmianSearch = true;
                }
                requestData();
            };

            /**
             * [toggleOpenPanel description] 下拉或收起面板
             * @param  {[type]} index [description] 当前面板的index
             * @return {[type]}       [description]
             */
            $scope.toggleOpenPanel = function (index) {
                $scope.status.isOpenedPanel[index] = !$scope.status.isOpenedPanel[index];
                $scope.status.curPanelIndex = index; // 新增一个下标值供后面使用
                if ($scope.data.panels[index].DOCUMENTS) {
                    return;
                }
                queryItemsByPanel(index);
            };

            /**
             * [requestESSearch description] 请求ES列表数据
             * @return {[type]} [description]
             */
            function requestESSearch() {
                var params;
                if ($scope.data.areaId !== '') {
                    params = {
                        serviceid: 'mlf_hybasesearch',
                        methodname: 'queryForShareTopicAndArea',
                        searchParams: getESSearchParamsByArea(),
                    };
                } else {
                    params = {
                        serviceid: 'mlf_hybasesearch',
                        methodname: 'queryForTongYiGongGaoDoc',
                        searchParams: getESSearchParams(),
                    };
                }
                $scope.loadingPromise = trsHttpService
                    .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function (data) {
                        // $scope.data.items = data.DATA;
                        $scope.page = data.PAGER;
                        $scope.data.items = [];
                        $timeout(function () {
                            if ($scope.params.docType === '2') {
                                $scope.data.items = dealDataForhasPhoto(data);
                            } else {
                                $scope.data.items = data.DATA;
                            }
                        });
                        storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID', 'gxgkDetail');
                        localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
                        $scope.data.operFlags = [];
                        return initOperFlag(data.DATA);
                    })
                    .then(function () {
                        getDraftRecord($scope.data.items);
                        if ($scope.params.docType !== '2') {
                            requestListImg($scope.data.items);
                        }
                        getGroupIssuedCounts($scope.data.items);
                    });
            }

            /**
             * [dealDataForhasPhoto description] 图集模式下图片处理
             * @param   {[object]}  data   [data description]
             * @return  {[array]}          [return description]
             */
            function dealDataForhasPhoto(data) {
                angular.forEach(data.DATA, function (value, key) {
                    if (angular.isArray(value.DOC_PICTURELIST) && value.DOC_PICTURELIST.length > 0) {
                        value.WIDTH = value.DOC_PICTURELIST[0].WIDTH;
                        value.HEIGHT = value.DOC_PICTURELIST[0].HEIGHT;
                    }
                });
                return data.DATA;
            }

            /**
             * [getESSearchParams description]设置ES检索参数
             * @return {[json]} [description]
             */
            function getESSearchParams() {
                var searchParams = {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [
                        {
                            // searchField: "docType",
                            searchField: 'docType',
                            keywords: $scope.docType.curValue.value,
                        },
                        {
                            searchField: 'newsType',
                            keywords: $scope.basicParams.nodeId,

                        },
                        {
                            searchField: 'ORIGINALTYPE',
                            keywords: $scope.params.OriginalType == '0' ? '' : $scope.params.OriginalType,
                        },
                        {
                            searchField: 'timeType',
                            keywords: $scope.data.fromdate ? $scope.data.fromdate + ';' + $scope.data.untildate : '0',
                        },
                        {
                            searchField: $scope.keyType.curValue.value,
                            keywords: $scope.data.keywords,
                        },
                        {
                            searchField: 'isOnlyMedia',
                            keywords: $scope.status.isMedia,
                        },
                        {
                            searchField: '_sort',
                            keywords: 'time',
                        }
                    ],
                };
                if ($scope.status.isCountyFeed) {
                    searchParams.searchFields.push({
                        searchField: 'fromTenantId',
                        keywords: $scope.params.fromTenantId
                    });
                }
                return JSON.stringify(searchParams);
            }

            /**
             * [getESSearchParamsByArea description]设置ES检索参数（地域）
             * @return {[json]} [description]
             */
            function getESSearchParamsByArea() {
                var searchParams = {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [
                        {
                            searchField: 'contentType',
                            keywords: 'area',
                        },
                        {
                            searchField: 'typeValue',
                            keywords: $scope.data.areaId == '-1' ? '-1' : $scope.data.areaId.split('_')[1],
                        },
                        {
                            searchField: 'newsType',
                            keywords: '',
                        },
                        {
                            searchField: 'ORIGINALTYPE',
                            keywords: $scope.params.OriginalType == '0' ? '' : $scope.params.OriginalType,
                        },
                        {
                            searchField: 'timeType',
                            keywords: $scope.data.fromdate ? $scope.data.fromdate + ';' + $scope.data.untildate : '0',
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.docType.curValue.value,
                        },
                        {
                            searchField: '',
                            keywords: $scope.data.keywords,
                        },
                        {
                            searchField: 'isOnlyMedia',
                            keywords: $scope.status.isMedia,
                        },
                        {
                            searchField: '_sort',
                            keywords: 'time',
                        }
                    ],
                };
                if ($scope.status.isCountyFeed) {
                    searchParams.searchFields.push({
                        searchField: 'fromTenantId',
                        keywords: $scope.params.fromTenantId
                    });
                }
                return JSON.stringify(searchParams);
            }

            /**
             * [requestImgFlow description] 请求图片流列表
             * @return {[type]} [description]
             */
            function requestImgFlow() {
                // 初始化清空页面
                $scope.params.OriginalType = $scope.params.OriginalType == '0' ? '' : $scope.params.OriginalType;
                $scope.data.itemCounts = 0;
                var params = angular.copy($scope.params);
                params.methodname = 'queryShareDocsForCloud';
                if ($scope.status.takeDraftStatus !== 2) {
                    params.singStatus = $scope.status.singStatus;
                } else {
                    params.singStatus = undefined;
                    delete params.singStatus;
                }
                params.PageSize = $scope.page.PAGESIZE;
                params.CurrPage = $scope.page.CURRPAGE;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    dealDataForhasPhoto(data);
                    $scope.data.items = [];
                    $timeout(function () {
                        $scope.data.items = data.DATA;
                    });
                    // $scope.data.items = $scope.data.items.concat(data.DATA);
                    $scope.page = data.PAGER;
                    // $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                    initOperFlag(data.DATA).then(function () {
                        // 图集稿：初始化取签见撤重
                        $timeout(function () {
                            for (var i = 0; i < $scope.data.items.length; i++) {
                                if (!$scope.data.items[i].lastLineHide) {
                                    $scope.data.itemCounts++;
                                }
                            }
                        }, 500);
                        storageListenerService.previewPageTurningStorage(data.DATA, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                        localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
                    });
                });
            }

            /**
             * [pageChanged description] 分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function () {
                requestData(true);
                resourceCenterService.scrollTop($element);
            };

            /**
             * [panelLoadMore description] 当前面板加载更多
             * @param  {[type]} index    [description] 当前面板的index
             * @param  {[type]} currPage [description] 当前面板的页码
             * @return {[type]}          [description]
             */
            $scope.panelLoadMore = function (index) {
                $scope.data.panels[index].currPage++;
                queryItemsByPanel(index);
            };

            /**
             * [loadMore description] 图集-加载更多图片
             * @return {[type]} [description]
             */
            $scope.imgLoadMore = function () {
                $scope.page.CURRPAGE++;
                requestData();
            };

            /**
             * [showSelectedArea description] 数据地域信息的级联菜单获取数据
             * @param  {[type]} node [description] 当前节点
             * @return {[type]}      [description]
             */
            $scope.showSelectedArea = function (node) {
                var deffer = $q.defer();
                resourceCenterService.getArea(node).then(function (data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            };

            /**
             * [searchWithArea description] 根据地域信息筛选稿件
             * @return {[type]} [description]
             */
            $scope.searchWithArea = function () {
                if ($scope.data.casDataArea.length === 0) {
                    return;
                }
                $scope.data.area = angular.copy($scope.data.casDataArea); // 当前选中的地域信息数组
                $scope.data.areaId = $scope.data.casDataArea[0][$scope.data.casDataArea.length - 1].id;
                if ($scope.data.areaId != '-1') {
                    $scope.status.isESSearch = true;
                    $scope.page.CURRPAGE = '1';
                    requestData();
                }
            };

            /**
             * [UGCSearch description] UGC检索
             * @return  {[type]}  [return description]
             */
            function UGCSearch() {
                $scope.data.selectedArrat = [];
                var params = {
                    serviceid: 'mlf_ugc',
                    methodname: 'queryArticles',
                    Method: 'queryArticles',
                    MetaCategoryId: !$scope.status.isDataOfFirst ? $stateParams.nodeid : '',
                    SearchWord: $scope.data.keywords,
                    ContainPage: '1',
                    CurrPage: $scope.page.CURRPAGE - 1,
                    PageSize: $scope.page.PAGESIZE,
                    start: $scope.data.fromdate,
                    end: $scope.data.untildate,
                    FirstClassId: $scope.status.isDataOfFirst ? $stateParams.nodeid : '',
                    // takeDraftStatus: $scope.status.takeDraftStatus
                };
                params.articleType = getUGCArticleType();
                // if ($scope.status.takeDraftStatus !== 2) {
                //     params.singStatus = $scope.status.singStatus;
                //     params.products = $scope.status.products;
                // }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    $scope.data.selectedArray = [];
                    $scope.status.UGCSearch = true;
                    $scope.ITEMCOUNT = !data || !data.data || !data.data.totalResults ? [] : data.data.totalResults;
                    data = !data || !data.data || !data.data.ldata ? [] : data.data.ldata;
                    angular.forEach(data, function (value, key) {
                        value.METADATAID = value.id + ''; // 转成
                        value.DOCTYPEID = value.docType + '';
                    });
                    if ($scope.status.hasphoto) {
                        $scope.data.items = data;
                    } else {
                        $scope.data.UGCsearchItems = data;
                    }
                    // cacheCurPageIds(data);
                    // 缓存打开面板后的选项
                    // selectedCurrentsArray(data);
                    initOperFlag(data);
                    storageListenerService.previewPageTurningStorage(data, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                    localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
                });
            }

            /**
             * [fullTextSearch description] 全文检索
             * @param   {[type]}  ev  [ev description] 按下回车也能提交
             * @return  {[type]}      [return description]
             */
            $scope.fullTextSearch = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if ($scope.status.isUGC) {
                        $scope.status.UGCSearch = true;
                        $scope.page.CURRPAGE = '1';
                        $scope.data.items = [];
                        UGCSearch();
                    } else {
                        $scope.status.isESSearch = true;
                        $scope.page.CURRPAGE = '1';
                        $scope.data.items = [];
                        requestData();
                    }
                }
            };

            /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description] 当前数据
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function (item) {
                var index = $scope.data.selectedArray.indexOf(item);
                index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
            };

            /**
             * [panelIsSelected description] 当前面板稿件是否全部选中
             * @param  {[type]} items [description] 当前面板
             * @return {[type]}       [description]
             */
            $scope.panelIsSelected = function (items) {
                if (!items) {
                    return false;
                }
                if (items.length === 0) {
                    return false;
                }
                for (var i = 0; i < items.length; i++) {
                    if ($scope.data.selectedArray.indexOf(items[i]) < 0) {
                        return false;
                    }
                }
                return true;
            };

            /**
             * [selectPanel description] 全选当前面板的稿件
             * @param  {[type]} items [description] 当前面板
             * @return {[type]}       [description]
             */
            $scope.selectPanel = function (items) {
                if (!!items) {
                    var panelAllSelected = true;
                    for (var i = 0; i < items.length; i++) {
                        if ($scope.data.selectedArray.indexOf(items[i]) < 0) {
                            $scope.data.selectedArray.push(items[i]);
                            panelAllSelected = false;
                        }
                    }
                    if (panelAllSelected === true) {
                        for (var j = 0; j < items.length; j++) {
                            if ($scope.data.selectedArray.indexOf(items[j]) > -1) {
                                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(items[j]), 1);
                            }
                        }
                    }
                }
            };

            /**
             * [selectAll description] 全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function () {
                if ($scope.params.DocType !== '2') {
                    $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
                } else {
                    // 只全选显示部分的稿件，未显示部分的稿件不选中
                    if ($scope.data.selectedArray.length == $scope.data.itemCounts) {
                        $scope.data.selectedArray = [];
                    } else {
                        var displayedItems = [];
                        for (var k = 0; k < $scope.data.items.length; k++) {
                            if (!$scope.data.items[k].lastLineHide) {
                                displayedItems.push($scope.data.items[k]);
                            }
                        }
                        $scope.data.selectedArray = [].concat(displayedItems);
                    }
                }
            };

            /**
             * [singleGraphMode description] 是否为单图模式
             * @return {[type]} [description]
             */
            $scope.singleGraphMode = function () {
                $scope.page.CURRPAGE = 1;
                $scope.data.items = [];
                $scope.status.singleGraph = !$scope.status.singleGraph;
                requestData();
            };

            /**
             * [panelMemory description] 记忆当前面板的数据
             * @param  {[type]} panelIndex [description] 当前面板所在的index
             * @return {[type]}            [description]
             */
            $scope.panelMemory = function (panelIndex) {
                storageListenerService.previewPageTurningStorage($scope.data.panels[panelIndex].DOCUMENTS, 'METADATAID,DOCTYPEID', 'gxgkDetail');
                localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
            };

            /** --------- 稿件操作开始 --------- */
            /**
             * [ description] 取稿
             * @return {[type]} [description]
             */
            $scope.openTakeDraftModal = function (from) {
                if (!from) {
                    if (!selectedSingleDoctype()) {
                        modalDialog.alertType('批量取稿只允许选择一种稿件类型', '', 'error', 'confirm', function () { });
                        return;
                    }
                }
                var ids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                var params;
                if ($scope.status.isUGC === true) {
                    params = {
                        serviceid: 'mlf_ugc',
                        methodname: 'takeArticle',
                        Method: 'takeArticle',
                        ID: ids,
                        SourceName: '资源中心-共享稿库-' + $scope.basicParams.nodename,
                    };
                } else {
                    var DocNodes = [];
                    for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                        var doc = {};
                        doc.docid = Number($scope.data.selectedArray[i].METADATAID);
                        doc.nodeid = Number($scope.data.selectedArray[i].CATEGORYID);
                        DocNodes.push(doc);
                    }
                    params = {
                        serviceid: 'mlf_fusionmyrelease',
                        methodname: 'fetch',
                        MetaDataIds: ids,
                        SourceName: '资源中心-共享稿库-' + $scope.basicParams.nodename,
                        nodeId: $scope.status.isDataOfFirst ? $scope.data.selectedArray[0].CATEGORYID : $scope.basicParams.nodeId,
                        DocNodes: JSON.stringify(DocNodes),
                    };
                }
                var isOnlyOne = !(ids.split(',').length > 1);
                var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray, $scope.status.isUGC);
                modalInstance.result.then(
                    function () {
                        initOperFlag($scope.data.selectedArray);
                        getDraftRecord($scope.data.selectedArray);
                        $scope.data.selectedArray = [];
                        getRelatedMedias($scope.data.panels[$scope.status.curPanelIndex].DOCUMENTS, $scope.status.curPanelIndex);
                    },
                    function () {
                        initOperFlag($scope.data.selectedArray);
                        getDraftRecord($scope.data.selectedArray);
                        $scope.data.selectedArray = [];
                    }
                );
            };

            /**
             * [selectedDoctype description] 判断选中稿件是否属于同一类型openTakeDraftModal
             * @return {[type]} [description]
             */
            function selectedSingleDoctype() {
                var doctype = $scope.data.selectedArray[0].DOCTYPEID;
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if (doctype !== $scope.data.selectedArray[i].DOCTYPEID) {
                        return false;
                    }
                }
                return true;
            }

            /**
             * [CreationAxis description] 个人素材
             * @return  {[type]}  [return description]
             */
            $scope.CreationAxis = function () {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                }
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if ($scope.data.selectedArray[i].DOCTYPEID > 2) {
                        modalDialog.alertType('只能添加新闻和图集!', '', 'error', false, '');
                        return;
                    }
                }
                var ids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                var params;
                if ($scope.status.isUGC === true) {
                    params = {
                        serviceid: 'mlf_ugc',
                        methodname: 'createCreations',
                        Method: 'articleInfo',
                        ID: ids,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if (data.message) {
                            modalDialog.alertType('', data.message, 'error', false, function () {
                                $scope.data.selectedArray = [];
                            });
                        } else {
                            modalDialog.alertType('该稿件已成功加入创作轴!', '', 'success', false, function () {
                                $scope.data.selectedArray = [];
                            });
                        }
                    });
                } else {
                    params = {
                        MetaDataIds: ids,
                        channelName: $scope.basicParams.channelName,
                    };
                    resourceCenterService.setCreation(params).then(function (data) {
                        if (data.message) {
                            modalDialog.alertType('', data.message, 'error', false, function () {
                                $scope.data.selectedArray = [];
                            });
                        } else {
                            modalDialog.alertType('添加成功!', '', 'success', false, function () {
                                $scope.data.selectedArray = [];
                            });
                        }
                    });
                }
            };

            /**
             * [printBtn description] 打印
             * @return {[type]} [description]
             */
            $scope.printBtn = function () {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                }
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if ($scope.data.selectedArray[i].DOCTYPEID > 2) {
                        modalDialog.alertType('只能打印新闻和图集!', '', 'error', false, '');
                        return;
                    }
                }
                if ($scope.status.isUGC === true) {
                    angular.forEach($scope.data.selectedArray, function (value, key) {
                        requestPrintData(value);
                    });
                } else {
                    angular.forEach($scope.data.selectedArray, function (value, key) {
                        // share
                        requestPrintVersion(value).then(function (data) {
                            requestPrintData(value, data);
                        });
                    });
                }
            };

            /**
             * [requestPrintVersion description] 打印请求流程版本
             * @param  {[type]} item [description] 选中数据
             * @return {[type]}      [description]
             */
            function requestPrintVersion(item) {
                var deferred = $q.defer();
                $scope.loadingPromise = trsHttpService
                    .httpServer(
                        trsHttpService.getWCMRootUrl(),
                        {
                            serviceid: 'mlf_metadatalog',
                            methodname: 'query',
                            MetaDataId: item.METADATAID,
                        },
                        'get'
                    )
                    .then(function (data) {
                        deferred.resolve(data.DATA);
                    });
                return deferred.promise;
            }

            /**
             * [requestPrintData description] 打印请求详情
             * @param  {[type]} item    [description] 选中数据
             * @param  {[type]} version [description] 流程版本
             * @return {[type]}         [description]
             */
            function requestPrintData(item, version) {
                var params;
                if ($scope.status.isUGC === true) {
                    params = {
                        serviceid: 'mlf_ugc',
                        methodname: 'queryArticles',
                        Method: 'articleInfo',
                        ID: item.METADATAID,
                    };
                } else {
                    params = {
                        serviceid: 'mlf_myrelease',
                        methodname: $scope.status.methodname[item.DOCTYPEID],
                        MetaDataId: item.METADATAID,
                    };
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    var result = data;
                    data.VERSION = version;
                    data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    $scope.data.printResult.push(result);
                    if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                        trsPrintService.trsPrintShare($scope.data.printResult);
                        $scope.data.printResult = [];
                    }
                });
            }

            /**
             * [moveUp description]提前操作
             * @return {[type]} [description]
             */
            $scope.moveUp = function () {
                var params;
                var ids = trsspliceString.spliceString($scope.data.selectedArray, 'DOCSHARERELID', ',');
                params = {
                    serviceid: 'mlf_sharedoc',
                    methodname: 'shareDocsToForward',
                    ShareDocRelIds: ids,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        modalDialog.alertType('稿件提前成功!', '', 'success', false, '');
                        requestData();
                    },
                    function(data) {
                        modalDialog.alertType('稿件提前失败!', '', 'error', false, '');
                        $scope.data.selectedArray = [];
                    }
                );
            };

            /**
             * [rejection description]退稿弹框
             *
             * @return  {[type]}  [return description]
             */
            $scope.rejection = function() {
                if ($scope.data.selectedArray.length > 1) {
                    modalDialog.alertType('每次最多退稿一篇稿件！', '', 'warning', 'confirm', '');
                    return;
                }
                var modalInstance = resCtrModalService.rejectionWithAppendix({
                    docInfo: $scope.data.selectedArray[0]
                });
                modalInstance.result.then(
                    function (data) {
                        requestData();
                        $scope.data.selectedArray = [];
                    }
                );
            };

            /**
             * [collect description] 收藏
             * @return {[type]} [description]
             */
            $scope.collect = function () {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                }
                if (canCollect()) {
                    modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', 'confirm', '');
                    return;
                }
                var ids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                var params;
                if ($scope.status.isUGC === true) {
                    params = {
                        serviceid: 'mlf_ugc',
                        methodname: 'collectUgcDoc',
                        Method: 'articleInfo',
                        ID: ids,
                    };
                } else {
                    params = {
                        channelName: $scope.basicParams.channelName,
                        MetaDataIds: ids,
                    };
                }
                resourceCenterService.collectDocs(params).then(function (data) {
                    modalDialog.alertType('收藏成功!', '', 'success', false, '');
                    $scope.data.selectedArray = [];
                });
            };

            /**
             * [canCollect description]判断能否收藏
             *
             * @return  {[type]}  [return description]
             */
            function canCollect() {
                return $scope.data.selectedArray.some(function (item) {
                    return item.DOCTYPEID != 1 && item.DOCTYPEID != 2 && item.DOCTYPEID != 7 && item.DOCTYPEID != 4;
                });
            }

            /**
             * [export description] 导出
             * @return {[type]} [description]
             */
            $scope.export = function () {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                }
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if ($scope.data.selectedArray[i].DOCTYPEID > 2) {
                        modalDialog.alertType('只能导出新闻和图集!', '', 'error', false, '');
                        return;
                    }
                }
                var params;
                if ($scope.status.isUGC === true) {
                    params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportUGCDocs',
                        Method: 'articleInfo',
                        ID: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    };
                } else {
                    params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportWordFile',
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    };
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function (data) {
                        if ($scope.status.isUGC === true) {
                            window.open('/wcm/app/file/read_file.jsp?FileName=' + data.substring(1, data.indexOf('"', 1)));
                        } else {
                            window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                        }
                    },
                    function (data) {
                        if (data.REPORTS[0].ISSUCCESS == 'true') {
                            window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                        }
                    }
                );
            };

            /**
             * [openReserveDraftModal description] 预留
             * @return {[type]} [description]
             */
            $scope.openReserveDraftModal = function () {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                }
                if (!selectedSingleDoctype()) {
                    modalDialog.alertType('批量预留只允许选择一种稿件类型', '', 'error', 'confirm', function () { });
                    return;
                }
                var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.data.selectedArray, $scope.status.isUGC);
                resCtrModalServiceModal.result.then(function (result) {
                    var metadataids = '';
                    angular.forEach(result.items, function (n, i) {
                        metadataids += ',' + n.METADATAID;
                    });
                    delete result.items;
                    if ($scope.status.isUGC === true) {
                        result.serviceid = 'mlf_ugc';
                        result.methodname = 'takeArticle';
                        result.Method = 'takeArticle';
                        result.ID = metadataids.substr(1);
                        result.SourceName = '资源中心-共享稿库-' + $scope.basicParams.nodename;
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), result, 'post').then(
                            function (data) {
                                modalDialog.alertType('预留成功!', '', 'success', false, '');
                                requestData();
                            },
                            function () {
                                $scope.data.selectedArray = [];
                            }
                        );
                    } else {
                        angular.forEach(result.items, function (n, i) {
                            metadataids += ',' + n.METADATAID;
                        });
                        result.MetaDataIds = metadataids.substr(1);
                        delete result.items;
                        result.SourceName = '资源中心-共享稿库-' + $scope.basicParams.nodename;
                        // result.nodeId = $scope.basicParams.nodeId;
                        result.nodeId = $scope.status.isDataOfFirst ? $scope.data.selectedArray[0].CATEGORYID : $scope.basicParams.nodeId;
                        $scope.loadingPromise = resourceCenterService.delayFetch(result).then(function (data) {
                            modalDialog.alertType('预留成功!', '', 'success', false, '');
                            if ($scope.params.DocType !== 2) {
                                requestData();
                            } else {
                                $scope.data.selectedArray = [];
                            }
                        });
                    }
                });
            };

            /**
             * [commonDeleteDrafts description] 普通删除稿件
             * @return {[type]} [description]
             */
            $scope.commonDeleteDrafts = function () {
                shareDocApiService.commonDeleteDrafts($scope).then(function() {
                    requestData();
                }, function() {
                    requestData();
                });
            };

            /**
             * [adminDeleteDrafts description] 管理员删除稿件// 20200608更改为管理员撤稿
             * @return {[type]} [description]
             */
            $scope.adminDeleteDrafts = function () {
                shareDocApiService.adminDeleteDrafts($scope).then(function() {
                    requestData();
                }, function() {
                    requestData();
                });
            };

            /**
             * [outSending description] 邮件外发
             * @return {[type]} [description]
             */
            $scope.outSending = function () {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                }
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if ($scope.data.selectedArray[i].DOCTYPEID > 2) {
                        modalDialog.alertType('邮件外发只支持新闻和图集!', '', 'error', false, '');
                        return;
                    }
                }
                editingCenterService.outSending('', function (result) {
                    outSendingDraft(result.selectItems);
                });
            };

            /**
             * [outSendingDraft description] 邮件外发函数
             * @param  {[type]} items [description] 选中邮件
             * @return {[type]}       [description]
             */
            function outSendingDraft(items) {
                var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
                var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_mailoutgoingOper',
                    methodname: 'iRecordSendEmail',
                    Emails: userids,
                    MetaDataIds: draftids,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
                        requestData();
                    });
                });
            }

            /**
             * [scrollShowMore description] 滚动加载更多
             * @return {[type]} [description]
             */
            // $scope.scrollShowMore = function () {
            //     if ($scope.status.hasphoto && $scope.page.CURRPAGE < $scope.page.PAGECOUNT) {
            //         $scope.imgLoadMore();
            //     }
            // };

            /**
             * [scrollLoadMore description] 滚动加载更多
             * @param  {[type]} $event [description] 事件
             * @return {[type]}        [description]
             */
            $scope.scrollLoadMore = function ($event) {
                var index = 0;
                isToButtom(function () {
                    doLoadMore(index);
                });

                /**
                 * [doLoadMore description] 加载更多
                 * @param   {[number]}  index  [index description] 数组下标
                 * @return  {[type]}           [return description]
                 */
                function doLoadMore(index) {
                    if (index + 1 > $scope.data.panels.length) {
                        return;
                    }
                    var items = $scope.data.panels[index];
                    if (items.pageCount === undefined || items.DOCUMENTS === undefined) {
                        queryItemsByPanel(index).then(function () {
                            $scope.status.isOpenedPanel[index] = true;
                        });
                    } else if (items.currPage < items.pageCount) {
                        $scope.panelLoadMore(index);
                    } else {
                        index++;
                        doLoadMore(index);
                    }
                }
            };

            /**
             * [isToButtom description] 判断是否到底
             * @param   {[type]}  callback  [callback description]
             * @return  {[type]}            [return description]
             */
            function isToButtom(callback) {
                var $parentEl = $element.find('.resource_body_part');
                var parentHeight = $parentEl[0].offsetHeight;
                var $parentEl2 = $parentEl.children().eq(0);
                var parentEl2Height = $parentEl2[0].offsetHeight;
                var scrollTop = $parentEl.scrollTop();
                if (parentEl2Height - parentHeight - scrollTop <= -5) {
                    if ($scope.status.scrollPromise) {
                        $timeout.cancel($scope.status.scrollPromise);
                        $scope.status.scrollPromise = null;
                    }
                    $scope.status.scrollPromise = $timeout(callback, 500);
                }
            }

            /**
             * [getRelatedMediaIcon description] 获取相关媒体的icon字
             * @param  {[type]} relatedMedia [description]
             * @return {[type]}              [description]
             */
            $scope.getRelatedMediaIcon = function (relatedMedia) {
                var iconObj = {};
                if (relatedMedia.ISSUBMIT == '1') {
                    iconObj = {
                        '1': '#icon-duan-xuanzhong',
                        '2': '#icon-wang-xuanzhong1',
                        '3': '#icon-bao-xuanzhong',
                        '4': '#icon-xin_s',
                        '5': '#icon-bo_s',
                        '17': '#icon-dy-3',
                        '18': '#icon-bjh-3',
                        '19': '#icon-qie-3',
                    };
                } else {
                    iconObj = {
                        '1': '#icon-duan',
                        '2': '#icon-wang',
                        '3': '#icon-bao',
                        '4': '#icon-xin',
                        '5': '#icon-bo',
                        '17': '#icon-dy-2',
                        '18': '#icon-bjh-2',
                        '19': '#icon-qie-2',
                    };
                }
                relatedMedia.icon = iconObj[relatedMedia.MEDIATYPE];
            };

            /**
             * [gotoDetail description]图集模式细览跳转
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.goToDetail = function (item) {
                var params = {
                    docid: item.id,
                    metadataid: item.METADATAID,
                    type: item.DOCTYPEID || item.doctype,
                    nodeid: item.CATEGORYID,
                    isugc: $scope.status.isUGC
                };
                var url = $state.href('resourcegxgkdetail', params);
                window.open(url, '_blank');
            };

            /**
             * [switchList 切换列表模式与版面模式]
             *
             * @param   {[type]}  mode  [mode description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.switchList = function (mode) {
                $scope.status.listMode = mode;
                resSharedService.setListMode(mode);
                requestData();
            };

            /**
             * [showVersionTime 流程版本时间与操作日志]
             *
             * @param   {[type]}  item  [item 稿件对象]
             * @param   {[type]}  isUGC  [item 稿件对象]
             *
             * @return  {[type]}        [return description]
             */
            $scope.showVersionTime = function (item) {
                if (!$scope.status.btnRights['source.sharedoc.chakanversion']) {
                    return;
                }
                editingCenterService.getVersionTime(item, true, $scope.status.isUGC, $scope.status.isCrossTenant);
            };

            // 用于数据双向绑定，将指令里的方法、参数绑定到上面来，在父控制器里可以直接调用
            $scope.compositeFilter = {};
            $scope.screenWrap = function() { // 收起筛选和展开筛选的方法
                $scope.status.screenWrapSelected = !$scope.status.screenWrapSelected;
                // $scope.compositeFilter.saveStorage('screenWrapSelected', $scope.status.screenWrapSelected);
            };

            /**
             * [showGgdwWrap description]
             * @param   {[type]}  flag  [flag description]
             * @return  {[type]}        [return description]
             */
            $scope.showGgdwWrap = function (flag) {
                $scope.status.showGgdwWrap = flag;
            };

            /**
             * [showGgdwWrap description]
             * @return  {[type]}        [return description]
             */
            $scope.searchSharedTenant = function() {
                if ($scope.data.SharedTenantName === '') {
                    $scope.data.sharedTenant.data = $scope.data.originArray;
                    $scope.params.fromTenantId = '';
                    requestData();
                } else {
                    $scope.data.sharedTenant.data = $scope.data.originArray.filter(screenSharedTenant);
                }
            };

            /**
             * [screenSharedTenant description]
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            function screenSharedTenant(item) {
                return item.FromTenantName.includes($scope.data.SharedTenantName); 
            }

            $scope.chooseTenant = function(item) {
                $scope.data.SharedTenantName = item.FromTenantName;
                // $scope.status.showGgdwWrap = false;
                $scope.params.fromTenantId = item.FromTenantId;
                requestData();
            };
        },
    ]);
